<template>
    <rkm-modal
        large
        ref="Modal"
        title="Telefones"
    >
        <CidadaoTelefone :telefones="telefones" />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import CidadaoTelefone from '@/components/cadastro/cidadao/Telefone'

// Vuex.
import { mapGetters } from 'vuex'

// Mixins.
import { object } from '@/mixins'

export default {
    components: { CidadaoTelefone },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        paciente: null,
        telefones: []
    }),
    methods: {
        open(paciente) {

            this.paciente = paciente
            this.telefones = this.clone(paciente.telefones)

            this.$refs.Modal.show()
        },
        save() {

            this.paciente.telefones = this.clone(this.telefones)

            this.$refs.Modal.hide()
        },
    },
    mixins: [object]
}
</script>